import { Table } from "@tanstack/react-table";

import { DataTablePagination } from "./DataTable.Pagination";

interface DataTableFooterProps {
  table: Table<any>;
  totalDataCount: number | undefined;
  paginationState?: {
    hasNext?: boolean;
    hasPrev?: boolean;
    onNext?: () => void;
    onPrev?: () => void;
  };
  /** When true, renders as a plain <div> instead of <tfoot> (for use outside a <table>) */
  pinned?: boolean;
}

const DataTableFooter = ({ table, totalDataCount, paginationState, pinned = false }: DataTableFooterProps) => {
  const content = (
    <div className="flex size-full h-12 items-center justify-between border-t border-grey-300 px-6">
      <div>{totalDataCount !== undefined && <span className="body-mono text-grey-600">{totalDataCount} Items</span>}</div>
      <DataTablePagination table={table} paginationState={paginationState} />
    </div>
  );

  if (pinned) {
    return <div className="shrink-0 bg-white">{content}</div>;
  }

  return (
    <tfoot className="sticky bottom-0 z-100 bg-white">
      <tr>
        <td colSpan={table.getVisibleFlatColumns().length}>{content}</td>
      </tr>
    </tfoot>
  );
};

export { DataTableFooter };
